import { create } from 'zustand';

/** Estado de UI global sin persistir: el buscador (Ctrl K) se abre desde el encabezado y el teclado. */
export const useUiStore = create((set) => ({
    buscadorAbierto: false,
    abrirBuscador: () => set({ buscadorAbierto: true }),
    cerrarBuscador: () => set({ buscadorAbierto: false }),
    setBuscador: (v) => set({ buscadorAbierto: !!v }),
}));
